import Component from "vue-class-component";
import $ from "jquery";
import { DetailCalculPaieArretSurImageDto } from "../../../dto/GenApi.iNotPaie.Dto/DetailCalculPaieArretSurImageDto";
import { VueBase } from "../../Controls/VueBase";
import { CalculPaieArretSurImageDto } from "../../../dto/GenApi.iNotPaie.Dto/CalculPaieArretSurImageDto";

@Component
export default class ModalArretSurImage extends VueBase {
	public DetailCalculPaies: DetailCalculPaieArretSurImageDto[] = [];
	public codeRubrique?: string = "";
	public libelleRubrique?: string = "";
	public codeRubriqueProchainArret = "";

	public Init(data: CalculPaieArretSurImageDto): void {
    	this.DetailCalculPaies = data.Details;
    	this.codeRubrique = data.Rubrique.CodeRubrique;
    	this.libelleRubrique = data.Rubrique.LibelleRubrique;
    	this.codeRubriqueProchainArret = "";
	}

	public annuler(): void {
    	$("#modalArretSurImage").modal("hide");
	}

	public Suivant(): void {
    	this.$emit("Suivant", this.codeRubriqueProchainArret);
	}
}




// WEBPACK FOOTER //
// ./src/components/calculDePaie/modalArretSurImage/modalArretSurImage.ts